import React from 'react';
import { testimonials } from '../data/wf';
export function Testimonials() {
  // Hidden until authentic WF GOTOWY reviews are added in data/wf.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-278" data-mp="3fz5sgaaeu6ml">
      <div className="mx-auto max-w-6xl" data-id="element-279" data-mp="3b1cl3dxdf6kq">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-280" data-mp="3b0aycc6zsvn6">
          Co mówią <em className="text-red-700" data-id="element-281" data-mp="36wmpzrajdw0v">nauczyciele</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-282" data-mp="31ybfrfgbxji4">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-283" data-mp="2x2w50wdmc3px">
              <div className="text-sm text-amber-500" aria-label="5 na 5 gwiazdek" data-id="element-284" data-mp="2s3079evil8it">
                <span aria-hidden="true" data-id="element-285" data-mp="v8dnhrk7kmf1">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-286" data-mp="qalko2i0zfw2">
                „{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-287" data-mp="h4n4wev9c5ci">
                <span className="font-semibold text-slate-900" data-id="element-288" data-mp="m5kn2rg9oze0">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-289" data-mp="780jnoz0rc9y"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}